import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

const options = {
    icon: 'success',
    timer: 2000,
};

Vue.use(VueSweetalert2, options);
